import moment from "moment";
import ScheduleStatusLogModel from "./ScheduleStatusLogModel";
import ProcessScheduleCollection from "@/collections/lab/ProcessScheduleCollection";
import ScheduleStatusLogCollection from "@/collections/lab/ScheduleStatusLogCollection";
import SampleCollection from "@/collections/lab/SampleCollection";
import InstrumentCollection from "@/collections/lab/InstrumentCollection";
import ScheduleStatusCollection from "@/collections/lab/ScheduleStatusCollection";
import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import StaffModel from "@/models/lab/StaffModel";

export default class ScheduleModel extends LabServiceModel {
  modelName() {
    return "schedule";
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      staff_id: null,
      process_type:null,
      date: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      laboratory: null,
      staff: null,
      process_schedules: [],
      schedule_status_logs: [],
      current_schedule_status_log: null,
      samples: [],
      instrument_instances: []
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      process_type: val => this.nullStringMutator(val),
      staff_id: val => this.nullStringMutator(val),
      date: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  name() {
    return moment(this.date).format("LL");
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, "laboratory");
  }
  getStaff() {
    return this.getRelatedModel(StaffModel, "staff");
  }
  getProcessSchedules() {
    return this.getRelatedCollection(
      new ProcessScheduleCollection(),
      "process_schedules"
    );
  }
  getScheduleStatusLogs() {
    return this.getRelatedCollection(
      new ScheduleStatusLogCollection(),
      "schedule_status_logs"
    );
  }
  getCurrentScheduleStatusLog() {
    return this.getRelatedModel(
      ScheduleStatusLogModel,
      "current_schedule_status_log"
    );
  }
  getSamples() {
    return this.getRelatedCollection(new SampleCollection(), "samples");
  }
  getInstruments() {
    if (this.id) {
      const process = this.getProcessSchedules().first();

      if (process) {
        const instrumentInstances = process.getInstrumentInstances();

        if (instrumentInstances && instrumentInstances.length) {
          const instruments = instrumentInstances.getInstruments();

          if (instruments && instruments.length) {
            return instruments;
          }
        }
      }
    }

    return new InstrumentCollection();
  }
  setStatus(name) {
    return new Promise((resolve, reject) => {
      const statuses = new ScheduleStatusCollection();

      statuses.getFilter().filterEquals("status", name);

      return statuses.fetch().then(
        () => {
          const status = statuses.first();

          if (!status) {
            return reject(`${name} schedule status could not be found`);
          }

          const currentStatus = this.getCurrentScheduleStatusLog();

          if (currentStatus.id === status.id) {
            return reject(`${name} schedule status is already set`);
          }

          const log = new ScheduleStatusLogModel({
            schedule_id: this.id,
            schedule_status_id: status.id,
            start_date: moment().format("YYYY-MM-DD HH:mm:ss")
          });

          return log.save().then(
            () => {
              return resolve(log);
            },
            () => {
              return reject(`${name} schedule status could not be set`);
            }
          );
        },
        () => {
          return reject(`${name} schedule status could not be found`);
        }
      );
    });
  }
}
